module.exports = __webpack_public_path__ + "img/ranqi.dd084ff2.png";